import Emitter from '../core/Emitter'

export const STATES = {
    DRAGGING: 'is-dragging'
}

export class SwipeDetect extends Emitter {
    constructor(element, options = {
        threshold: 75
    }) {
        super()

        this.element = element
        this.options = options

        this.element.addEventListener('mousedown', this.handleTouchStart, false)
        this.element.addEventListener('mouseup', this.handleTouchEnd, false)
        this.element.addEventListener('mousemove', this.handleTouchMove, false)
        this.element.addEventListener('click', this.handleClick)

        this.xDown = null
        this.yDown = null
        this.successfulSwipe = false
    }

    destroy() {
        this.element.removeEventListener('mousedown', this.handleTouchStart, false)
        this.element.removeEventListener('mouseup', this.handleTouchEnd, false)
        this.element.removeEventListener('mousemove', this.handleTouchMove, false)
        this.element.removeEventListener('click', this.handleClick)
    }

    handleTouchStart = event => {
        const firstTouch = event
        this.xDown = firstTouch.clientX
        this.yDown = firstTouch.clientY
        this.element.classList.add(STATES.DRAGGING)
    }
    
    handleTouchMove = event => {
        if (!this.xDown || !this.yDown) {
            return
        }

        const xUp = event.clientX
        const yUp = event.clientY

        const xDiff = this.xDown - xUp
        const yDiff = this.yDown - yUp

        if ((Math.abs(xDiff) - this.options.threshold <= 0) && Math.abs(yDiff) - this.options.threshold <= 0) {
            return
        }

        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            if (xDiff > 0) {
                this.emit('swipe-left')
                this.successfulSwipe = true
            } else {
                this.emit('swipe-right')
                this.successfulSwipe = true
            }
        } else {
            if (yDiff > 0) {
                this.emit('swipe-up')
                this.successfulSwipe = true
            } else {
                this.emit('swipe-down')
                this.successfulSwipe = true
            }
        }

        this.xDown = null
        this.yDown = null
    }

    handleTouchEnd = event => {
        this.xDown = null
        this.yDown = null
        this.element.classList.remove(STATES.DRAGGING)
    }

    handleClick = event => {
        if (!this.successfulSwipe) {
            return
        }

        event.preventDefault()
        this.successfulSwipe = false
    }
}


